import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './FormWrapper.module.scss';

const FormWrapper = ({ className, ...props }) => {
  return <Form {...props} className={cn(styles.form, className)} />;
};

export default FormWrapper;
